import { useParams } from 'react-router-dom'
import React, { useState, useEffect } from 'react';
import ENDPOINT from '../../constants/api-endpoints';
import { ProgressBar } from 'react-loader-spinner'
import { Link } from 'react-router-dom';

var parse = require('html-react-parser');

const Testimonial = () => {
    let { slug } = useParams();
    let apiUrl = ENDPOINT.TESTIMONIAL_DATA;
    if (slug !== undefined) {
        apiUrl = ENDPOINT.TESTIMONIAL_DATA + '/' + slug;
    }
    const [pageData, setPage] = useState([]);
    useEffect(() => {
        fetch(apiUrl)
            .then((response) => response.json())
            .then((responseData) => {
                setPage(responseData);
            })
            .catch((err) => {
                console.log(err.message);
            });
    }, []);
    if (pageData.length !== 0) {
        if (slug !== undefined) {
            let pageTitle = '';
            let pageContent = '';
            pageTitle = pageData.data.title;
            pageContent = pageData.data.content;
            if (!pageContent.data) {
                return (
                    <>
                        <div className="innerpage-banner">
                            <Link to="/">
                                <img src={`${process.env.PUBLIC_URL}/assets/img/blog.jpeg`} alt="" />
                            </Link>
                        </div>
                        <div className="container">
                            <div className="innerpage">
                                <h1>{pageTitle}</h1>
                                {parse(pageContent)} 
                            </div>
                        </div>
                    </>
                );
            } else {
                return (
                    <div className="container">
                        <div className="innerpage">
                            <center>
                            <ProgressBar
                                    height="80"
                                    width="80"
                                    ariaLabel="progress-bar-loading"
                                    wrapperStyle={{textAlign: 'center', justifyContent: 'center'}}
                                    wrapperClass="progress-bar-wrapper"
                                    borderColor = '#f8de00'
                                    barColor = '#570101'
                                />
                            </center>
                        </div>
                    </div>
                );
            }
        } else {
            return (
                <>
                    <div className="innerpage-banner">
                        <Link to="/">
                            <img src={`${process.env.PUBLIC_URL}/assets/img/blog.jpeg`} alt="" />
                        </Link>
                    </div>
                    <div className="innerpage">
                        <div className="container">
                            <h1>Testimonials</h1>
                            {pageData.data.map((item, i) => {
                                    return (
                                        <div className="testimonial">
                                            <div className="row">
                                                <div className="col-md-2">
                                                    <div className="testi-block">
                                                        <img src={item.image} alt="" />
                                                    </div>
                                                </div>
                                                <div className="col-md-10">
                                                <h3>{item.title}</h3>
                                                {parse(item.content)}
                                                <h4>{item.postBy}</h4>     
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                </>
            );
        }
    } else {
        return (
            <div className="container">
                <div className="innerpage">
                    <center>
                    <ProgressBar
                            height="80"
                            width="80"
                            ariaLabel="progress-bar-loading"
                            wrapperStyle={{textAlign: 'center', justifyContent: 'center'}}
                            wrapperClass="progress-bar-wrapper"
                            borderColor = '#f8de00'
                            barColor = '#570101'
                        />
                    </center>
                </div>
            </div>
        );
    }
};
  
export default Testimonial;
